import firebase from "firebase/app";
import "firebase/database";

import { API_KEY } from "../utils/api";

const config = {
  apiKey: API_KEY,
  authDomain: "wonderful-barbershop.firebaseapp.com",
  databaseURL: "https://wonderful-barbershop.firebaseio.com",
  projectId: "wonderful-barbershop",
  storageBucket: "wonderful-barbershop.appspot.com",
  messagingSenderId: "993038981886",
  appId: "1:993038981886:web:a1324f855a6ddbb8a4a3af",
  measurementId: "G-RM4483JTJX",
};

firebase.initializeApp(config);

export const database = firebase.database();
